import React, {Component} from 'react'
import PropTypes from 'prop-types'
import TableData from "./TableData"

class TableBody extends Component {
    render() {
        const {data} = this.props

        return (
            <tbody className='TableBody'>
            <tr>
                <TableData
                    type='text'
                    data='Quá hạn in'
                    classType='groupPrint'
                    keyQuery=''
                    valueQuery=''
                />
                <TableData
                    type='data'
                    data={data.printedOvertime}
                    classType='groupPrint'
                    keyQuery='typeOverTime'
                    valueQuery='printed_overtime'
                />
                <TableData
                    type='text'
                    data={data.printedOvertimeBatchItems}
                    classType='groupPrint'
                    keyQuery=''
                    valueQuery=''
                />

                <TableData
                    type='text'
                    data='Quá hạn ép'
                    classType='groupTransfer first'
                    keyQuery=''
                    valueQuery=''
                />
                <TableData
                    type='data'
                    data={data.transferredOvertime}
                    classType='groupTransfer'
                    keyQuery='typeOverTime'
                    valueQuery='transferred_overtime'
                />
                <TableData
                    type='text'
                    data={data.transferredOvertimeBatchItems}
                    classType='groupTransfer'
                    keyQuery=''
                    valueQuery=''
                />

                <TableData
                    type='text'
                    data='Quá hạn qc'
                    classType='groupSew'
                    keyQuery=''
                    valueQuery=''
                />
                <TableData
                    type='data'
                    data={data.sewedOvertime}
                    classType='groupSew first'
                    keyQuery='typeOverTime'
                    valueQuery='sewing_overtime'
                />
                <TableData
                    type='text'
                    data={data.sewedOvertimeBatchItems}
                    classType='groupSew'
                    keyQuery=''
                    valueQuery=''
                />
            </tr>

            <tr>
                <TableData
                    type='text'
                    data='Đang in'
                    classType='groupPrint'
                    keyQuery=''
                    valueQuery=''
                />
                <TableData
                    type='data'
                    data={data.printing}
                    classType='groupPrint'
                    keyQuery='status'
                    valueQuery='printing'
                />
                <TableData
                    type='text'
                    data={data.printingBatchItems}
                    classType='groupPrint'
                    keyQuery=''
                    valueQuery=''
                />

                <TableData
                    type='text'
                    data='Đang ép'
                    classType='groupTransfer first'
                    keyQuery=''
                    valueQuery=''
                />
                <TableData
                    type='data'
                    data={data.transferring}
                    classType='groupTransfer'
                    keyQuery='status'
                    valueQuery='transferring'
                />
                <TableData
                    type='text'
                    data={data.transferringBatchItems}
                    classType='groupTransfer'
                    keyQuery=''
                    valueQuery=''
                />

                <TableData
                    type='text'
                    data='Đang qc'
                    classType='groupSew first'
                    keyQuery=''
                    valueQuery=''
                />
                <TableData
                    type='data'
                    data={data.sewing}
                    classType='groupSew'
                    keyQuery='status'
                    valueQuery='sewing'
                />
                <TableData
                    type='text'
                    data={data.sewingBatchItems}
                    classType='groupSew'
                    keyQuery=''
                    valueQuery=''
                />
            </tr>

            <tr>
                <TableData
                    type='text'
                    data='Chờ in'
                    classType='groupPrint'
                    keyQuery=''
                    valueQuery=''
                />
                <TableData
                    type='data'
                    data={data.pending}
                    classType='groupPrint'
                    keyQuery='status'
                    valueQuery='pending'
                />
                <TableData
                    type='text'
                    data={data.pendingBatchItems}
                    classType='groupPrint'
                    keyQuery=''
                    valueQuery=''
                />

                <TableData
                    type='text'
                    data='Chờ ép'
                    classType='groupTransfer first'
                    keyQuery=''
                    valueQuery=''
                />
                <TableData
                    type='data'
                    data={data.printed}
                    classType='groupTransfer'
                    keyQuery='status'
                    valueQuery='printed'
                />
                <TableData
                    type='text'
                    data={data.printedBatchItems}
                    classType='groupTransfer'
                    keyQuery=''
                    valueQuery=''
                />

                <TableData
                    type='text'
                    data='Chờ qc'
                    classType='groupSew first'
                    keyQuery=''
                    valueQuery=''
                />
                <TableData
                    type='data'
                    data={data.wait_to_sew}
                    classType='groupSew'
                    keyQuery='status'
                    valueQuery='wait_to_sew'
                />
                <TableData
                    type='text'
                    data={data.waitToSewBatchItems}
                    classType='groupSew'
                    keyQuery=''
                    valueQuery=''
                />
            </tr>
            </tbody>
        )
    }
}

TableBody.propTypes = {
    data: PropTypes.object.isRequired
}

export default TableBody